import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';

const STATE_DEFINITION = `${API_PREFIX}/state-definition`;

@Injectable({
  providedIn: 'root',
})
export class StateDefinitionService {
  private readonly http = inject(HttpClient);

  checkNameUnique(name: string, id?: number): Observable<boolean> {
    const params = new HttpParams().set('name', name).set('excludedId', String(id ?? 0));

    return this.http
      .get<
        boolean | { data?: boolean }
      >(resolveUrl(`${STATE_DEFINITION}/check-name-unique`), { params })
      .pipe(
        map(response => {
          if (typeof response === 'boolean') {
            return response;
          }

          if (typeof response?.data === 'boolean') {
            return response.data;
          }

          return false;
        }),
      );
  }
}
